import SimpleTablePage from "../common/SimpleTablePage";
import { Link } from "react-router";
import { Input } from "antd";
import DebounceSelect from "../common/DebounceSelect";
import { api } from "../common/api";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    sorter: true,
    key: "id",
    fixed: "left",
    width: 70,
    render: (id) => <Link to={`${id}`}>{id}</Link>,
  },
  {
    title: "Targa",
    key: "plate",
    dataIndex: "plate",
    sorter: true,
    ellipsis: true,
    width: 100,
  },
  {
    title: "Categoria",
    key: "type",
    dataIndex: "type",
    render: (type) => type?.name,
    sorter: true,
    ellipsis: true,
    width: 100,
  },
  {
    title: "Descrizione",
    key: "description",
    dataIndex: "description",
    sorter: true,
    ellipsis: true,
    width: 100,
  },
];

const filterItems = [
  {
    name: "plate",
    label: "Targa",
    formItem: { children: <Input allowClear /> },
  },
  {
    name: "description",
    label: "Descrizione",
    formItem: { children: <Input allowClear /> },
  },
  {
    name: "type",
    label: "Categoria",
    readableValue: (value) => value && JSON.parse(value).label,
    formItem: {
      props: {
        getValueProps: (value) => ({ value: value && JSON.parse(value) }),
        normalize: (value) => value && JSON.stringify(value),
      },
      children: (
        <DebounceSelect
          allowClear
          minSize={0}
          fetchOptions={(name) =>
            api.vehicleType
              .list({ name, pageSize: 9999 })
              .then(({ data }) => data.map((type) => ({ label: type.name, value: type.id })))
          }
        />
      ),
    },
  },
];

const fetchVehicles = (params) =>
  api.vehicle.list({
    ...params,
    type: params.type ? JSON.parse(params.type).value : undefined,
  });

export default function Vehicles() {
  return (
    <SimpleTablePage
      title={"Veicoli"}
      description={"Gestisci e monitora i veicoli aziendali"}
      resource="vehicle"
      columns={columns}
      filterItems={filterItems}
      fetchFunction={fetchVehicles}
    />
  );
}
